export const formatMXN = (n = 0) =>
  Number(n).toLocaleString('es-MX', {
    style: 'currency',
    currency: 'MXN',
    maximumFractionDigits: 0,
  });
